export enum OrderByEnum {
    TransactionDate,
    FriendlyName,
    RxNumber,
    ActivityType,
    StartingQuantity,
    AddedQuantity,
    EndingQuantity
}